// extracted by mini-css-extract-plugin
export default {"container":"OnBoardingPageF_container__fxQ4u","containerText":"OnBoardingPageF_containerText__eqNsj","animation":"OnBoardingPageF_animation__rXEz1"};